import React, { useEffect, useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { useNavigate } from "react-router-dom";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import DeleteIcon from "@material-ui/icons/Delete";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import { athenaURL } from "../../env";
import * as appActions from "../../actions/appActions";
import * as virActions from "../../actions/virActions";
import { useDispatch, useSelector } from "react-redux";

import VirComfirmDialog from "../VirConfirmDialog/VirConfirmDialog";
import { Button } from "@packages/ui";
import getBrandFromUrl from "src/utils/getBrandFromUrl";

const windscreenProgress = [
  "Initialized",
  "IncidentDetails",
  "DamageDetails",
  "ReviewPage",
  "SubmissionPage",
];

const panelProgress = [
  "Initialized",
  "VehicleConditionAndPolice",
  "IncidentDetails",
  "OtherDriverDetails",
  "ThirdPartyDetail",
  "Witness",
  "DamageDetails",
  "ReviewPage",
  "SubmissionPage",
];

const useStyles = makeStyles((theme) => ({
  list: {
    backgroundColor: theme.palette.background.paper,
    maxHeight: 300,
  },
  image: {
    width: "70%",
    height: "60%",
  },
  root: {
    flexGrow: 1,
  },
  noVirFoundSubmit: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "20vh",
    fontFamily: "Arial, sans-serif",
    fontSize: "24px",
    fontWeight: "bold",
    color: "lightgrey",
    textAlign: "center",
  },
  noVirFoundDraft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "20vh",
    fontFamily: "Arial, sans-serif",
    fontSize: "18px",
    fontWeight: "bold",
    color: "lightgrey",
    textAlign: "center",
  },
}));

const VirListItemText = withStyles((theme) => ({
  primary: {
    fontSize: "0.7rem",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.25rem", // Larger font size for larger screens
    },
  },
  secondary: {
    fontSize: "0.6rem", // Default secondary text size
    [theme.breakpoints.up("sm")]: {
      fontSize: "1rem", // Larger secondary text size for larger screens
    },
  },
}))(({ classes, ...props }) => {
  return (
    <ListItemText
      classes={{
        primary: classes.primary,
        secondary: classes.secondary,
      }}
      {...props}
    />
  );
});

const getProgress = (virstatus, selectedType) => {
  if (virstatus === "SubmissionPage") {
    return 100;
  }
  if (selectedType === "windscreen") {
    const progress = windscreenProgress.indexOf(virstatus);
    return progress * 25;
  }
  const progress = panelProgress.indexOf(virstatus);
  // for now only two type
  return progress * 12.5;
};

const VirList = ({ virs, handleDelete, createLoading, handleCreate }) => {
  const styles = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authorization = useSelector((state) => state.vir.athenaAuth.authorization);
  const athenaRole = useSelector((state) => state.vir.athenaRole.role);

  const [tabValue, setTabvalue] = useState(0);
  const [open, setOpen] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const [selectedVir, setSelectedVir] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [continueLoading, setContinueLoading] = useState(false);
  const [virList, setVirList] = useState({
    draft: [],
    submited: [],
  });
  const [virStatus, setVirStatus] = useState("");
  const [selectedType, setSelectedType] = useState("");

  const brand = getBrandFromUrl().toLowerCase();

  useEffect(() => {
    const draft = virs.filter(
      (vir) =>
        vir.virstatus !== "SubmissionPage" &&
        vir.virstatus !== "Expired" &&
        vir.createdBy === athenaRole
    );

    const submitted = virs.filter((vir) => vir.virstatus === "SubmissionPage");
    setVirList({
      draft: draft,
      submited: submitted,
    });
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  const navigateBasedOnCustomer = async () => {
    await fetch(`${athenaURL}/vir/detail`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authorization}`,
      },
      mode: "cors",
      method: "POST",
      body: JSON.stringify({ virId: selectedVir.virid }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        const customerDriving = data.data.CustomerDriving;
        const path =
          customerDriving === "N"
            ? `/vehicleincidents/otherdriverdetails?brand=${brand}`
            : `/vehicleincidents/thirdpartydetails?brand=${brand}`;
        setContinueLoading(false);
        navigate(path);
      })
      .catch((error) => {
        dispatch(appActions.createToast({ type: "error", message: "Failed to continue" }));
        setDeleteLoading(false);
      });
  };

  const deleteVir = async () => {
    setDeleteLoading(true);
    await fetch(`${athenaURL}/vir/detail`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authorization}`,
      },
      mode: "cors",
      method: "DELETE",
      body: JSON.stringify({ virId: selectedVir.virid }),
    })
      .then((res) => res.json())
      .then((data) => {
        setOpen(false);
        handleDelete(selectedVir.virid);
        setOpen(false);
        // update the current vir list
        setVirList({
          draft: virList.draft.filter((vir) => vir.virid !== selectedVir.virid),
          submited: [...virList.submited],
        });
        setDeleteLoading(false);
        dispatch(
          appActions.createToast({
            type: "success",
            message: "Vir is removed",
          })
        );
      })
      .catch((error) => {
        dispatch(appActions.createToast({ type: "error", message: "Failed to delete" }));
        setDeleteLoading(false);
      })
      .finally(() => {
        setDeleteLoading(false);
      });
  };

  const closeDialog = () => {
    setOpen(false);
  };

  const openDialog = () => {
    setOpen(true);
  };

  function CircularProgressWithLabel(props) {
    return (
      <Box position="relative" display="inline-flex">
        <CircularProgress variant="determinate" {...props} />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography variant="caption" component="div" color="textSecondary">{`${Math.round(
            props.value
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }

  const continuePage = async () => {
    setNavOpen(false);
    setContinueLoading(true);
    if (virStatus.toLowerCase() === "submissionpage") {
      dispatch(
        virActions.resubmitVir({
          virId: selectedVir.virid,
          flag: true,
        })
      );
    } else {
      dispatch(
        virActions.resubmitVir({
          virId: selectedVir.virid,
          flag: false,
        })
      );
    }
    switch (virStatus.toLowerCase()) {
      case "incidentdetails":
        if (selectedType === "windscreen") {
          setContinueLoading(false);
          navigate(`/vehicleincidents/damagedetails?brand=${brand}`);
        } else if (selectedType === "panel") {
          await navigateBasedOnCustomer();
        }
        break;
      case "witness":
        setContinueLoading(false);
        navigate(`/vehicleincidents/damagedetails?brand=${brand}`);
        break;
      case "thirdpartydetail":
        setContinueLoading(false);
        navigate(`/vehicleincidents/witnessdetails?brand=${brand}`);
        break;
      case "damagedetails":
        setContinueLoading(false);
        navigate(`/vehicleincidents/damagedetails?brand=${brand}`);
        break;
      case "otherdriverdetails":
        setContinueLoading(false);
        navigate(`/vehicleincidents/thirdpartydetails?brand=${brand}`);
        break;
      case "vehicleconditionandpolice":
        setContinueLoading(false);
        navigate(`/vehicleincidents/incidentdetails?brand=${brand}`);
        break;
      case "reviewpage":
        setContinueLoading(false);
        navigate(`/vehicleincidents/reviewpage?brand=${brand}`);
        break;
      case "initialized":
        setContinueLoading(false);
        if (selectedType === "panel") {
          // Navigate to specific pages for the "panel" type
          navigate(`/vehicleincidents/vehicleconditionandpolice?brand=${brand}`);
        } else if (
          selectedType === "windscreen" ||
          selectedType === "interior" ||
          selectedType === "mechanical"
        ) {
          navigate(`/vehicleincidents/incidentdetails?brand=${brand}`);
        }
        break;
      case "submissionpage":
        setContinueLoading(false);
        if (selectedType === "panel") {
          // Navigate to specific pages for the "panel" type
          navigate(`/vehicleincidents/vehicleconditionandpolice?brand=${brand}`);
        } else if (
          selectedType === "windscreen" ||
          selectedType === "interior" ||
          selectedType === "mechanical"
        ) {
          navigate(`/vehicleincidents/incidentdetails?brand=${brand}`);
        }
        break;
      default:
    }
  };

  const handleClick = (vir, type) => {
    dispatch(
      virActions.detailVir({
        virId: vir.virid,
      })
    );
    dispatch(
      virActions.detailPatchVir({
        virId: vir.virid,
        data: {},
      })
    );
    dispatch(
      virActions.virSelectedType({
        selectedType: vir.virtype,
      })
    );
    dispatch(
      virActions.virSelectedId({
        selectedId: vir.virid,
      })
    );
    setSelectedVir(vir);
    setVirStatus(vir.virstatus);
    setSelectedType(vir.virtype);
    // setContinueType(type);
    setNavOpen(true);
  };

  const VirItem = ({ vir, isDraft, type }) => {
    return (
      <>
        <ListItem
          onClick={() => {
            handleClick(vir, type);
          }}
        >
          <ListItemAvatar>
            <CircularProgressWithLabel value={getProgress(vir.virstatus, selectedType)} />
          </ListItemAvatar>
          <VirListItemText
            primary={`Progress: ${vir.virstatus}`}
            secondary={`Created: ${formatDate(vir.createTime)}`}
          />
          {isDraft && (
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                aria-label="delete"
                onClick={() => {
                  setSelectedVir(vir);
                  openDialog();
                }}
              >
                <DeleteIcon />
              </IconButton>
            </ListItemSecondaryAction>
          )}
        </ListItem>
      </>
    );
  };

  return (
    <>
      <Grid item xs={12} md={12}>
        <Paper className={styles.root}>
          <Tabs
            value={tabValue}
            indicatorColor="primary"
            textColor="primary"
            onChange={(event, newValue) => setTabvalue(newValue)}
            centered
          >
            <Tab label="IN PROGRESS" />
            <Tab label="SUBMITTED" />
          </Tabs>
        </Paper>
        <div className={styles.list}>
          <List>
            {tabValue === 1 ? (
              virList.submited.length === 0 ? (
                <div className={styles.noVirFoundSubmit}>No Incident Report</div>
              ) : (
                virList.submited.map((vir, index) => {
                  return <VirItem key={index} vir={vir} isDraft={false} type="submitted" />;
                })
              )
            ) : virList.draft.length === 0 ? (
              <div className={styles.noVirFoundDraft}>
                <div style={{ paddingBottom: "30px" }}>No Incident Report</div>
                <Button
                  variant="contained"
                  component="span"
                  onClick={handleCreate}
                  disabled={createLoading}
                >
                  {createLoading ? <CircularProgress /> : "Create"}
                </Button>
              </div>
            ) : (
              virList.draft.map((vir, index) => {
                return <VirItem key={index} vir={vir} isDraft={true} type="draft" />;
              })
            )}
          </List>
        </div>
        <VirComfirmDialog
          open={open}
          handleClose={closeDialog}
          content="Click ‘OK’ to continue deleting this incident report."
          execute={deleteVir}
          loading={deleteLoading}
        />

        <VirComfirmDialog
          open={navOpen}
          handleClose={() => setNavOpen(false)}
          content="Click ‘OK’ to view and edit this incident report. "
          execute={continuePage}
          loading={continueLoading}
        />
      </Grid>
    </>
  );
};

export default VirList;
